"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CLOSE_ANIMATION_DURATION = exports.DEFAULT_OPEN_ANIMATION_DURATION = void 0;
/* eslint-disable no-unused-expressions */
var react_1 = __importDefault(require("react"));
var style_1 = require("./style");
exports.DEFAULT_OPEN_ANIMATION_DURATION = 300;
exports.DEFAULT_CLOSE_ANIMATION_DURATION = 300;
var setProperty = function (property, value) {
    document.querySelector('html').style.setProperty(property, value);
};
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutside = function (event) {
            var _a, _b;
            var _c = _this.props, isMobile = _c.isMobile, onOverlayClick = _c.onOverlayClick, shouldDisplayOverlay = _c.shouldDisplayOverlay;
            var isClickOutsideModal = !((_b = (_a = _this.modalRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(event.target));
            if (!isMobile &&
                shouldDisplayOverlay &&
                isClickOutsideModal) {
                onOverlayClick === null || onOverlayClick === void 0 ? void 0 : onOverlayClick();
            }
        };
        _this.disableScroll = function () {
            var shouldDisableScroll = _this.props.shouldDisableScroll;
            if (shouldDisableScroll) {
                setProperty('overflow', 'hidden');
            }
        };
        _this.enableScroll = function () {
            var shouldDisableScroll = _this.props.shouldDisableScroll;
            if (shouldDisableScroll) {
                setProperty('overflow', null);
            }
        };
        _this.handleClose = function () {
            var _a, _b;
            (_b = (_a = _this.props).onCloseStart) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.setState({
                isClosing: true
            }, _this.triggerUnmount);
        };
        _this.handleOpen = function () {
            var _a, _b;
            _this.resetTimeout();
            (_b = (_a = _this.props).onOpenStart) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.setState({
                isActive: true,
                isClosing: false
            }, function () {
                var _a, _b;
                _this.disableScroll();
                (_b = (_a = _this.props).onOpenEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
        };
        _this.handleDesktopEventPropagation = function (event) {
            event.stopPropagation();
        };
        _this.resetTimeout = function () {
            if (_this.timeoutID !== null) {
                clearTimeout(_this.timeoutID);
                _this.timeoutID = null;
            }
        };
        _this.triggerUnmount = function () {
            var closingAnimationDuration = _this.props.closingAnimationDuration;
            _this.timeoutID = window.setTimeout(function () {
                _this.setState({
                    isActive: false,
                    isClosing: false
                }, function () {
                    var _a, _b;
                    _this.enableScroll();
                    (_b = (_a = _this.props).onCloseEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
                });
            }, closingAnimationDuration);
        };
        _this.renderDesktopModal = function () {
            var _a = _this.props, children = _a.children, className = _a.className, closingAnimationDuration = _a.closingAnimationDuration, openingAnimationDuration = _a.openingAnimationDuration, style = _a.style, topOffset = _a.topOffset;
            var _b = _this.state, isActive = _b.isActive, isClosing = _b.isClosing;
            if (!isActive) {
                return null;
            }
            return (react_1.default.createElement(style_1.DesktopModalCanvas, null,
                react_1.default.createElement(style_1.DesktopModalWrapper, { className: className, closingAnimationDuration: closingAnimationDuration, isClosing: isClosing, onClick: _this.handleDesktopEventPropagation, openingAnimationDuration: openingAnimationDuration, ref: _this.modalRef, style: style, topOffset: topOffset },
                    react_1.default.createElement("div", { className: 'Modal__content' }, children))));
        };
        _this.renderMobileModal = function () {
            var _a = _this.props, children = _a.children, className = _a.className, closingAnimationDuration = _a.closingAnimationDuration, openingAnimationDuration = _a.openingAnimationDuration, style = _a.style, topOffset = _a.topOffset;
            var _b = _this.state, isActive = _b.isActive, isClosing = _b.isClosing;
            if (!isActive) {
                return null;
            }
            return (react_1.default.createElement(style_1.MobileModalWrapper, { className: className, closingAnimationDuration: closingAnimationDuration, isClosing: isClosing, openingAnimationDuration: openingAnimationDuration, style: style, topOffset: topOffset },
                react_1.default.createElement("div", { className: 'Modal__content' }, children)));
        };
        _this.renderModal = function () {
            var isMobile = _this.props.isMobile;
            return ((isMobile)
                ? _this.renderMobileModal()
                : _this.renderDesktopModal());
        };
        _this.renderOverlay = function () {
            var _a = _this.props, closingAnimationDuration = _a.closingAnimationDuration, onOverlayClick = _a.onOverlayClick, openingAnimationDuration = _a.openingAnimationDuration, shouldBlurBackground = _a.shouldBlurBackground, shouldDisplayOverlay = _a.shouldDisplayOverlay;
            var _b = _this.state, isActive = _b.isActive, isClosing = _b.isClosing;
            if (!isActive || !shouldDisplayOverlay) {
                return null;
            }
            return (react_1.default.createElement(style_1.ModalOverlay, { className: 'Modal__Overlay', closingAnimationDuration: closingAnimationDuration, isClosing: isClosing, onClick: onOverlayClick, openingAnimationDuration: openingAnimationDuration, shouldBlurBackground: shouldBlurBackground }));
        };
        _this.state = {
            isActive: false,
            isClosing: false
        };
        _this.timeoutID = null;
        _this.modalRef = react_1.default.createRef();
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        if (this.props.isActive) {
            this.handleOpen();
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    };
    Modal.prototype.componentDidUpdate = function (prevProps) {
        if ((this.props.isActive !== prevProps.isActive) &&
            (this.props.isActive !== this.state.isActive || this.state.isClosing)) {
            if (!this.props.isActive) {
                return this.handleClose();
            }
            return this.handleOpen();
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        var _a, _b, _c, _d;
        if (this.state.isActive && !this.state.isClosing) {
            this.resetTimeout();
            this.enableScroll();
            (_b = (_a = this.props).onCloseStart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.props).onCloseEnd) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
        document.removeEventListener('mousedown', this.handleClickOutside);
    };
    Modal.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderOverlay(),
            this.renderModal()));
    };
    Modal.defaultProps = {
        closingAnimationDuration: exports.DEFAULT_CLOSE_ANIMATION_DURATION,
        isActive: true,
        isMobile: true,
        openingAnimationDuration: exports.DEFAULT_OPEN_ANIMATION_DURATION,
        shouldBlurBackground: true,
        shouldDisableScroll: true,
        shouldDisplayOverlay: true,
        topOffset: 0
    };
    return Modal;
}(react_1.default.Component));
exports.default = Modal;
__exportStar(require("./types"), exports);
